import { createTranslationsPageProvider } from '@edreamsodigeo/frontend-core';
const TripSummaryTranslationsPageProvider = createTranslationsPageProvider({
  checkout: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "[request]" */`@edreamsodigeo/frontend-checkout/translations/${brand}/${locale}/flight_summary`),
  flightResults: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "[request]" */`@edreamsodigeo/frontend-flights-results/translations/${brand}/${locale}/default.js`),
  prime: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "[request]" */`@edreamsodigeo/frontend-prime/translations/${brand}/${locale}/default.js`),
  userAuthentication: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "[request]" */`@edreamsodigeo/frontend-user-authentication/translations/${brand}/${locale}/home.js`)
});
export default TripSummaryTranslationsPageProvider;